import React, { useState, useEffect } from 'react'
import { Edit, required, SimpleForm, useNotify, useRedirect, useTranslate, useResourceContext, useEditController, BooleanInput  } from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { cardServices } from 'src/services/payment/card/card.service'
import { financialEntityServices } from 'src/services/payment/financialEntity/financialEntity.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const PaymentMethodEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const resourceName = useResourceContext()
  const { record  } = useEditController({ resource: resourceName, id })

  const [ cardLoading, setCardLoading ] = useState(false)
  const [ card, setCard ] = useState([])
  const [ financialEntityLoading, setFinancialEntityLoading ] = useState(false)
  const [ financialEntity, setFinancialEntity ] = useState([])

  useEffect(() => {
    getCard()
    getFinancialEntity()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.payment-method') }
    })
    redirect('/payment-method')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.payment-method') }
    })
  }

  const getFinancialEntity = async () => {
    try {
      setFinancialEntityLoading(true)
      const financialEntities = await financialEntityServices.getByAll()
      if (financialEntities) {
        setFinancialEntity(financialEntities)
        setFinancialEntityLoading(false)
        return
      }
      notify(`card not found`, { type: 'error' })
      setFinancialEntityLoading(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setFinancialEntityLoading(false)
    }
  }

  const getCard = async () => {
    try {
      setCardLoading(true)
      const cards = await cardServices.getByAll()
      if (cards) {
        setCard(cards)
        setCardLoading(false)
        return
      }
      notify(`card not found`, { type: 'error' })
      setCardLoading(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setCardLoading(false)
    }
  }


  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_payment_method')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['short_name']} genderElement='femenine' />}>
          <Grid container spacing={3}>
          <EditInputsWrap label={translate('ra.field.financial_entity')} required>
              {financialEntityLoading ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  size='small'
                  optionsText={['long_name']}
                  fullWidth
                  label=''
                  source='financial_entity_id'
                  options={financialEntity}
                  validate={[required()]}
                  defaultValue={record?.financial_entity_id}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.card')} required>
              {cardLoading ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  size='small'
                  optionsText={['long_name']}
                  fullWidth
                  label=''
                  source='card_id'
                  options={card}
                  validate={[required()]}
                  defaultValue={record?.card_id}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
